import FilterStoreHours from "../filter";
import reqEmpresaHorario from "../../../../services/reqMultiTenant/reqEmpresaHorario";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterStoreHours = () => {
	const options = {
		id: "id_horario",
		ident: "storeHours",
		identFilter: "filterStoreHours",
		title: "Horários de Funcionamento",
		subTitle: "Cadastro da Empresa",
		notice: "A Modalidade permite flexibilidade: você pode definir horários diferentes para Loja e Delivery. Por exemplo, a loja pode continuar aberta para retirada enquanto o delivery já encerrou as operações.",
		tableColumns: [
			{ key: "dia_semana_str", label: "Dia da Semana", align: "left" },
			{ key: "hora_abertura_str", label: "Abertura", align: "center" },
			{ key: "hora_fechamento_str", label: "Fechamento", align: "center" },
			{ key: "tipo", label: "Tipo / Modalidade", align: "center" },
			{ key: "ativo", label: "Ativo", align: "center", format: "badgeAtivoSoft" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [
			{ id: 1, label: "Tipo / Modalidade", value: "tipo" },
			{ id: 2, label: "Dia Semana", value: "dia_semana" },
		],
	};

	const diasMap = {
		1: "Domingo",
		2: "Segunda-feira",
		3: "Terça-feira",
		4: "Quarta-feira",
		5: "Quinta-feira",
		6: "Sexta-feira",
		7: "Sábado",
	};

	const formatData = (item) => {
		if (!item) return item;

		const id_horario = item.id_horario || item.ID_HORARIO;
		const dia_semana = item.dia_semana || item.DIA_SEMANA;
		const hora_abertura = item.hora_abertura || item.HORA_ABERTURA;
		const hora_fechamento = item.hora_fechamento || item.HORA_FECHAMENTO;

		let abertura = "";
		if (hora_abertura) {
			abertura = String(hora_abertura).includes("T")
				? String(hora_abertura).split("T")[1].substring(0, 5)
				: String(hora_abertura).substring(0, 5);
		}

		let fechamento = "";
		if (hora_fechamento) {
			fechamento = String(hora_fechamento).includes("T")
				? String(hora_fechamento).split("T")[1].substring(0, 5)
				: String(hora_fechamento).substring(0, 5);
		}

		return {
			...item,
			id_horario,
			dia_semana_str: diasMap[dia_semana] || String(dia_semana || ""),
			hora_abertura_str: abertura,
			hora_fechamento_str: fechamento,
		};
	};

	const fetch = async (filterData, newPage) => {
		let { param, paramValue, active } = filterData;

		if (param === "dia_semana" && paramValue) {
			const search = paramValue.toLowerCase();
			if (search.includes("dom") || search.includes("ingo")) paramValue = "1";
			else if (search.includes("seg") || search.includes("gunda")) paramValue = "2";
			else if (search.includes("ter") || search.includes("rça")) paramValue = "3";
			else if (search.includes("qua") || search.includes("rta")) paramValue = "4";
			else if (search.includes("qui") || search.includes("nta")) paramValue = "5";
			else if (search.includes("sex") || search.includes("xta")) paramValue = "6";
			else if (search.includes("sab") || search.includes("sáb") || search.includes("bado")) paramValue = "7";
			else paramValue = "0";
		}

		const response = await reqEmpresaHorario.list(param, paramValue, active, newPage);

		if (response && response.data && Array.isArray(response.data)) {
			response.data = response.data.map(formatData);
		}

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqEmpresaHorario.listID(currentId);

		if (response && response.data) {
			const record = Array.isArray(response.data) ? response.data[0] : response.data;
			response.data = formatData(record);
		}

		return response;
	};

	const insert = async (data) => {
		return await reqEmpresaHorario.insert(data);
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterStoreHours} />
		</RegisterProvider>
	);
};

export default MainRegisterStoreHours;
